import Home from "views/Home/Home.js";
import HomeRedesign from "views/Home/HomeRedesign";
import Policies from "views/Policies/Policies";
import Reports from "views/Reports/Reports";
import Clients from "views/Clients/Clients.js";
import Client from "views/Clients/Client.js";
import ResourceRedesign from "views/Resources/ResourcesRedesign";
import ResourceFile from "views/Resources/ResourceFile";
import NewsView from "views/Pages/NewsView";
import New from "views/News/New";
import Wizard from "views/Forms/Wizard.js";
import Guest from "views/Forms/Guest.js";
import GuestRedesing from "views/Forms/GuestRedesing";
import SummaryRedesign from "views/Forms/SummaryRedesign";
import Document from "views/Pages/PdfView";
import HomePage from "views/Pages/Home";
import Widgets from "views/Widgets/Widgets.js";
import LoginPage from "views/Pages/LoginPage.js";
import LoginPageRedesign from "views/Pages/LoginPageRedesign.js";
import PaymentPayPal from "views/Pages/PaymentPayPal.js";
import ViewPolicy from "views/Pages/viewPolicy";
import TransactionsList from "views/Pages/transactionsList";
import Welcome from "views/Pages/Welcome";
import RecoveryPasswordPage from "views/Pages/RecoveryPasswordPageRedesign";
import ResetPasswordPage from "views/Pages/ResetPassowrd";
import LoginRedirected from "views/Pages/LoginRedirected";
import Resources from "views/Resources/Resources";
import Formatos from "views/Pages/Formatos";
import SaveQuotes from "views/SavedQuotes/SavedQuotes";
import Agencies from "views/Agencies/Agencies";
import Agency from "views/Agencies/Agency";
import Endorsement from "views/Endorsements/Endorsements";
import Cancellation from "views/Cancellations/Cancellations";
import User from "views/Users/User";
import Rates from "views/Rates/Rates";
import News from "views/News/News";
import Users from "views/Users/Users";
import MakesModels from "views/MakesModels/MakesModels";
import Make from "views/MakesModels/EditMake";
import Model from "views/MakesModels/EditModel";
import SecurityParameters from "views/SecurityParameters/SecurityParameters";

// @material-ui/icons
import Apps from "@material-ui/icons/Apps";
import DashboardIcon from "@material-ui/icons/Dashboard";
import Person from "@material-ui/icons/Person";
import { Save, SaveRounded } from "@material-ui/icons";
import FlashOn from "@material-ui/icons/FlashOn";
import Article from "@material-ui/icons/FileCopy";

import { checkIfIsKiosko, isAgent } from "components/Utils/utils.js";
import RatesForm from "views/Rates/Rates";

const isKiosko = checkIfIsKiosko();
const redesign = process.env.REACT_APP_REDESIGN;
const userType = localStorage.getItem("userType");

const Routes = [
  {
    path: "/recovery-password-page/:type?/:producerCode?",
    name: "Recovery password Page",
    rtlName: "هعذاتسجيل الدخول",
    mini: "L",
    rtlMini: "هعذا",
    redirect: true,
    component: RecoveryPasswordPage,
    layout: "/auth",
  },
  {
    path: "/home",
    name: "Home",
    icon: DashboardIcon,
    component: HomeRedesign,
    layout: "/admin",
  },
  {
    path: "/client/:id?",
    name: "Client Details",
    icon: DashboardIcon,
    redirect: true,
    component: Client,
    layout: "/admin",
  },
  {
    path: "/reset_password/:userId/:newPassKey/:producerCode?",
    name: "Recovery password Page",
    rtlName: "هعذاتسجيل الدخول",
    mini: "L",
    rtlMini: "هعذا",
    redirect: true,
    component: ResetPasswordPage,
    layout: "/auth",
  },
  {
    path: "/fastquote/:producerCode?",
    name: "New Quote",
    redirect: true,
    component: GuestRedesing,
    layout: "/guest",
  },
  {
    path: "/kiosko/:producerCode?",
    name: "New Quote",
    redirect: true,
    component: GuestRedesing,
    layout: "/guest",
  },
  {
    path: [1, 2].includes(userType)
      ? "/login-agent/:type?/:producerCode?"
      : "/login-customer/:type?/:producerCode?",
    name: "Logout",
    icon: "logout",
    component: LoginPageRedesign,
    layout: "/auth",
  },
  {
    path: "/redirected/:token/:userType",
    name: "Recovery password Page",
    rtlName: "هعذاتسجيل الدخول",
    mini: "L",
    rtlMini: "هعذا",
    redirect: true,
    component: LoginRedirected,
    layout: "/auth",
  },
  {
    path: "/checkTokenOneClick/:userId/:token",
    name: "One click",
    rtlName: "هعذاتسجيل الدخول",
    mini: "L",
    rtlMini: "هعذا",
    redirect: true,
    component: LoginPage,
    layout: "/auth",
  },
  {
    path: "/paymentPayPal",
    name: "Payment PayPal",
    redirect: true,
    component: PaymentPayPal,
    layout: "/admin",
  },
  {
    path: "/paymentPayPal",
    name: "Payment PayPal",
    redirect: true,
    component: PaymentPayPal,
    layout: "/guest",
  },
  {
    path: "/formatos",
    name: "Formatos",
    rtlName: "ملف تعريفي للمستخدم",
    mini: "VP",
    rtlMini: "شع",
    component: Formatos,
    redirect: true,
    layout: "/auth",
  },
  {
    path: "/viewPolicy/:id?/:type",
    name: "Policy view kiosko",
    redirect: true,
    component: ViewPolicy,
    layout: "/guest",
  },
  {
    path: "/transactionsLists",
    name: "Policy view kiosko",
    redirect: isAgent ? true : false,
    component: TransactionsList,
    layout: "/admin",
  },
  {
    path: "/login-customer/:type?/:producerCode?",
    name: "Login Page Redesign Customer",
    rtlName: "هعذاتسجيل الدخول",
    mini: "L",
    rtlMini: "هعذا",
    redirect: true,
    component: LoginPageRedesign,
    layout: "/auth",
  },
  {
    path: "/login-agent/:type?/:producerCode?",
    name: "Login Page Redesign Agent",
    rtlName: "هعذاتسجيل الدخول",
    mini: "L",
    rtlMini: "هعذا",
    redirect: true,
    component: LoginPageRedesign,
    layout: "/auth",
  },
  {
    path: "/confirmation/:producerCode?",
    name: "Confirmation sale",
    rtlName: "هعذاتسجيل الدخول",
    mini: "L",
    rtlMini: "هعذا",
    redirect: true,
    component: HomePage,
    layout: "/auth",
  },
  {
    path: "/guest/:id?",
    name: "Fast Quote",
    icon: FlashOn,
    component: Guest,
    redirect: true,
    layout: "/auth",
  },
  {
    path: "/summary/:id?",
    name: "Summary Quote",
    icon: FlashOn,
    component: SummaryRedesign,
    redirect: true,
    layout: "/guest",
  },
  {
    path: "/view/:id/:type?",
    name: "View Policy",
    rtlName: "ملف تعريفي للمستخدم",
    mini: "VP",
    rtlMini: "شع",
    component: ViewPolicy,
    redirect: true,
    layout: "/admin",
  },
  {
    path: "/welcome",
    name: "Welcome",
    rtlName: "ملف تعريفي للمستخدم",
    mini: "VP",
    rtlMini: "شع",
    component: Welcome,
    redirect: true,
    layout: "/admin",
  },
  {
    path: "/es",
    name: "Login es",
    icon: "login",
    redirect: true,
    component: LoginPageRedesign,
    layout: "/auth",
  },
  {
    path: "/en",
    name: "Login en",
    icon: "login",
    redirect: true,
    component: LoginPageRedesign,
    layout: "/auth",
  },
  {
    path: "/profile",
    name: "My Profile",
    icon: Person,
    component: Widgets,
    layout: "/admin",
  },
  {
    path: "/:language?/:id?",
    name: "New Quote",
    icon: Article,
    component: GuestRedesing,
    layout: "/guest",
  },
  {
    path: "/policyPdf/:type?/:policyNumber?",
    name: "Policy pdf",
    icon: Article,
    redirect: true,
    component: Document,
    layout: "/admin",
  },
  {
    path: "/resources",
    name: "Resource",
    icon: Article,
    component: ResourceRedesign,
    layout: "/admin",
  },
  {
    path: "/resourceFile/:category?/:fileName?",
    name: "Resource File",
    icon: Article,
    redirect: true,
    component: ResourceFile,
    layout: "/admin",
  },
  {
    path: "/new/:id?/",
    name: "New",
    icon: Article,
    redirect: true,
    component: NewsView,
    layout: "/admin",
  },
  {
    path: "/policies",
    name: "Policies",
    icon: DashboardIcon,
    redirect: isAgent ? false : true,
    component: Policies,
    layout: "/admin",
  },
  {
    path: "/reports",
    name: "Reports",
    icon: DashboardIcon,
    redirect: isAgent ? false : true,
    component: Reports,
    layout: "/admin",
  },
  {
    path: "/clients",
    name: "Clients",
    icon: DashboardIcon,
    redirect: isAgent ? false : true,
    component: Clients,
    layout: "/admin",
  },
  {
    path: "/savedQuotes",
    name: "Saved Quotes",
    icon: Article,
    component: SaveQuotes,
    layout: "/admin",
  },
  {
    path: "/agencies",
    name: "Agencies",
    icon: Article,
    redirect: userType != "1" ? true : false,
    component: Agencies,
    layout: "/admin",
  },
  {
    path: "/agency/:id?",
    name: "Agency",
    icon: Article,
    redirect: true,
    component: Agency,
    layout: "/admin",
  },
  {
    path: "/endorsement/:id?",
    name: "Endorsement",
    icon: Article,
    redirect: true,
    component: Endorsement,
    layout: "/admin",
  },
  {
    path: "/cancellation/:id?",
    name: "Cancellation",
    icon: Article,
    redirect: true,
    component: Cancellation,
    layout: "/admin",
  },
  {
    path: "/user/:agencyId?/:id?",
    name: "User",
    icon: Article,
    redirect: true,
    component: User,
    layout: "/admin",
  },
  {
    path: "/rates",
    name: "Rates",
    icon: Article,
    redirect: true,
    component: Rates,
    layout: "/admin",
  },
  {
    path: "/news",
    name: "News",
    icon: Article,
    redirect: true,
    component: News,
    layout: "/admin",
  },
  {
    path: "/newEdit/:id?",
    name: "News",
    icon: Article,
    redirect: true,
    component: New,
    layout: "/admin",
  },
  {
    path: "/users/",
    name: "Users",
    icon: Article,
    redirect: true,
    component: Users,
    layout: "/admin",
  },
  {
    path: "/parameters/",
    name: "Security Parameters",
    icon: Article,
    redirect: true,
    component: SecurityParameters,
    layout: "/admin",
  },
  {
    path: "/makesModels/",
    name: "Makes and Models",
    icon: Article,
    redirect: true,
    component: MakesModels,
    layout: "/admin",
  },
  {
    path: "/vehicleMake/:id?",
    name: "Vehicle Make",
    icon: Article,
    redirect: true,
    component: Make,
    layout: "/admin",
  },
  {
    path: "/vehicleModel/:id?",
    name: "Vehicle Model",
    icon: Article,
    redirect: true,
    component: Model,
    layout: "/admin",
  },
  
];

export default Routes;
